/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_EmptyInputs */

const fr_networks_list_empty = /** @type {(inputs: Networks_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun réseau ne correspond à ces critères.`)
};

const en_networks_list_empty = /** @type {(inputs: Networks_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No network matches these criteria.`)
};

/**
* | output |
* | --- |
* | "No network matches these criteria." |
*
* @param {Networks_List_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_empty = /** @type {((inputs?: Networks_List_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_empty(inputs)
	return en_networks_list_empty(inputs)
});